import axios from "axios";
import { routes } from "@/router/Routes";
import { interactionStore } from "@/stores/Stores";
import { AUTH_BASE_URL } from "@/common/config";
import { APIService } from "./APIService";

export class AuthService extends APIService {
  private static instance: AuthService;

  protected readonly authBaseUrl = AUTH_BASE_URL;

  private constructor() {
    super();
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public readonly postAuth = async (url: string, data: unknown) => {
    return axios.post(this.authBaseUrl + url, data);
  };

  public readonly login = async (email: string, password: string, security_code?: string, otp_session?: string) => {
    return this.postAuth(routes.auth.login, {
      username: email,
      password,
      security_code,
      otp_session,
    });
  };

  public readonly logout = async () => {
    return this.postAuth(routes.auth.logout, {});
  };

  public readonly register = async (username: string, password: string) => {
    return this.postAuth(routes.auth.register, {
      username,
      password,
      redirect: `${window.location.origin + routes.pages.login}?redirectTo=${interactionStore.redirectTo}&domain=${interactionStore.xdomain}`,
    });
  };

  public readonly confirmRegister = async (username: string, code: string) => {
    return this.postAuth(routes.auth.confirm, {
      username,
      code,
    });
  };

  public readonly refreshToken = async (refreshToken?: string, username?: string) => {
    return this.postAuth(routes.auth.refreshToken, {
      refresh_token: refreshToken,
      username,
    });
  };

  public readonly passwordChange = async (oldPassword: string, newPassword: string) => {
    return this.postAuth(routes.auth.passwordChange, {
      current_password: oldPassword,
      new_password: newPassword,
    });
  };

  public readonly passwordReset = async (email: string) => {
    return this.postAuth(routes.auth.passwordReset, {
      email,
      redirect: window.location.origin + routes.pages.createNewPassword,
    });
  };

  public readonly passwordResetConfirm = async (token: string, newPassword: string) => {
    return this.postAuth(routes.auth.passwordResetConfirm, {
      token,
      password: newPassword,
    });
  };
}
